// ##### 25-02-05 Komarov
import React from 'react';
// ##### Komarov 2025-07-26
import Image from '../../../Library/PageDevices/CartGallery/Image';

// ##### Komarov 2025-07-14
const BodyPageImg = ({ item, style = null }) => {
  return (
    <Image
      data-component="BodyPageImg"
      // ##### 24-03-21 Komarov
      alt="Banner"
      style={style}
      src={`${process.env.REACT_APP_SMART_PROTOCOL + item.text}`}
    />
  );
};

export default BodyPageImg;
